export default "__VITE_ASSET__BWVi5l2I__"